import { authService } from '@/models/auth';
/**
 * Where a signed in user starts.
 *
 * Resolved from the abilities the user actually holds rather than being a fixed guess a
 * route guard has to correct afterwards, which is what produced the login redirect loops.
 * Pass the route being guarded as `exclude` so a guard can never bounce back to itself.
 */
export function landingRoute(exclude = null) {
    if (exclude !== 'invoice.index' && authService.can('invoice.index')) {
        return { name: 'invoice.index' };
    }
    if (exclude !== 'dashboard' && authService.can('dashboard')) {
        return { name: 'dashboard' };
    }
    return { name: 'company.edit', params: { tab: 'info' } };
}
